export const emeaTableConstants= {
  EMEA_TABLE_LOADING: 'EMEA_TABLE_LOADING',
  EMEA_TABLE_SUCCESS: 'EMEA_TABLE_SUCCESS',
  EMEA_TABLE_FAILED: 'EMEA_TABLE_FAILED',

  EMEA_TABLE_COMMENT_LOADING: 'EMEA_TABLE_COMMENT_LOADING',
  EMEA_TABLE_COMMENT_SUCCESS: 'EMEA_TABLE_COMMENT_SUCCESS',
  EMEA_TABLE_COMMENT_FAILED: 'EMEA_TABLE_COMMENT_FAILED',
  EMEA_TABLE_COMMENT_RESET: 'EMEA_TABLE_COMMENT_RESET',
}